import { Phone, Flame } from "lucide-react";
import { BRAND, MENU } from "../data/restaurant";
import { Reveal, Stagger, StaggerItem } from "./motion/Reveal";

export default function DealsStrip() {
  return (
    <section id="deals" data-testid="deals-section" className="px-4 py-10 sm:px-6 sm:py-16">
      <div className="grain relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] border-4 border-jet bg-jet px-6 py-14 shadow-hard sm:px-12 sm:py-16">
        <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-ochre/20 blur-3xl" />
        <div aria-hidden="true" className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-crimson/30 blur-3xl" />

        <div className="relative grid grid-cols-1 items-center gap-12 lg:grid-cols-[auto_1fr]">
          <Reveal className="flex flex-col items-center gap-5 text-center">
            <div className="relative h-40 w-40 sm:h-48 sm:w-48">
              <svg viewBox="0 0 100 100" className="h-full w-full animate-spin-slow" aria-hidden="true">
                {Array.from({ length: 24 }).map((_, i) => {
                  const a = (Math.PI * i) / 12;
                  const r1 = i % 2 === 0 ? 49 : 37;
                  return (
                    <circle
                      key={i}
                      cx={50 + r1 * Math.cos(a)}
                      cy={50 + r1 * Math.sin(a)}
                      r={i % 2 === 0 ? 6.5 : 5}
                      fill={i % 2 === 0 ? "#FFB923" : "#D92124"}
                    />
                  );
                })}
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="font-display text-4xl font-black text-cream sm:text-5xl">$10</span>
                <span className="font-display text-xs font-extrabold uppercase tracking-widest text-sunshine">Deals</span>
              </div>
            </div>
            <p className="max-w-[220px] font-hand text-2xl font-bold leading-tight text-sunshine">In-person takeout deals only</p>
          </Reveal>

          <div>
            <Reveal>
              <p className="mb-3 inline-flex items-center gap-2 rounded-full border-2 border-sunshine bg-transparent px-4 py-1 text-xs font-bold uppercase tracking-[0.2em] text-sunshine">
                <Flame className="h-4 w-4" aria-hidden="true" />
                Deals &amp; Discounts
              </p>
              <h2 className="font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-cream sm:text-5xl">
                Big flavor. <span className="text-sunshine">Small bill.</span>
              </h2>
            </Reveal>

            <Stagger className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {MENU.deals10.map((deal) => (
                <StaggerItem key={deal}>
                  <div
                    data-testid="deal-card-item"
                    className="flex items-center justify-between rounded-2xl border-2 border-cream/25 bg-cream/5 px-5 py-4 transition-colors duration-200 hover:border-sunshine hover:bg-cream/10"
                  >
                    <span className="font-display text-base font-extrabold text-cream sm:text-lg">{deal}</span>
                    <span className="ml-3 shrink-0 font-display text-lg font-black text-sunshine">$10.00</span>
                  </div>
                </StaggerItem>
              ))}
            </Stagger>

            <Reveal delay={0.15} className="mt-9">
              <a
                href={BRAND.phoneHref}
                data-testid="deal-call-cta"
                className="inline-flex items-center gap-2 rounded-full border-[3px] border-cream bg-crimson px-8 py-4 font-display text-base font-extrabold uppercase text-cream shadow-[6px_6px_0_0_#FFB923] transition-all duration-200 hover:-translate-y-1 hover:shadow-[10px_10px_0_0_#FFB923]"
              >
                <Phone className="h-5 w-5" aria-hidden="true" />
                Call {BRAND.phoneDisplay} to grab yours
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
